/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Playing_BodyInputs */

const en_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On-course coaching: shot selection, course management, club gapping, and live decision-making in the moments that actually count.`)
};

const es_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching en el campo: selección de golpes, estrategia de campo, distancias entre palos y decisiones en tiempo real en los momentos que realmente importan.`)
};

const de_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching auf dem Platz: Schlagwahl, Platzstrategie, Distanzabstände zwischen den Schlägern und Entscheidungen in Echtzeit in den Momenten, die wirklich zählen.`)
};

const zh_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场上教学：击球选择、球场策略、各支球杆之间的距离间隔，以及在真正关键的时刻做出即时决策。`)
};

const ar_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدريب داخل الملعب: اختيار الضربات، وإدارة الملعب، وضبط المسافات بين المضارب، واتخاذ القرار في اللحظة نفسها عندما يهم ذلك فعلاً.`)
};

const fr_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching sur le parcours : choix de coups, stratégie de parcours, écarts de distance entre les clubs et décisions en temps réel dans les moments qui comptent vraiment.`)
};

const vi_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huấn luyện trên sân: chọn cú đánh, chiến thuật trên sân, khoảng cách giữa các gậy và quyết định tức thời trong những khoảnh khắc thực sự quan trọng.`)
};

const sw_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafunzo uwanjani: kuchagua aina ya pigo, mkakati wa uwanja, tofauti za umbali kati ya fimbo na kufanya maamuzi papo hapo katika nyakati zenye umuhimu kweli.`)
};

const th_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โค้ชบนสนาม: การเลือกช็อต การวางแผนเล่นในสนาม ระยะห่างของไม้กอล์ฟแต่ละเบอร์ และการตัดสินใจทันทีในจังหวะที่สำคัญจริงๆ`)
};

const bs_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening na terenu: izbor udaraca, strategija igre na terenu, razmaci u dužini udarca između palica i odluke u realnom vremenu u trenucima koji su zaista važni.`)
};

const ja_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースでのコーチング：ショット選択、コースマネジメント、クラブごとの飛距離の差、そして本当に大事な場面でのその場の判断。`)
};

const ko_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코스 레슨: 샷 선택, 코스 매니지먼트, 클럽별 거리 간격, 그리고 정말 중요한 순간의 실시간 판단.`)
};

const pt_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhamento em campo: escolha de tacadas, estratégia de campo, distâncias entre tacos e tomada de decisão em tempo real nos momentos que realmente importam.`)
};

const it_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento in campo: scelta dei colpi, strategia di gioco sul percorso, distanze tra i bastoni e decisioni in tempo reale nei momenti che contano davvero.`)
};

const sv_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coachning på banan: slagval, banstrategi, klubbavstånd och beslut i realtid i de ögonblick som verkligen räknas.`)
};

const nl_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coaching op de baan: slagkeuze, baanstrategie, afstandsverschillen tussen je clubs en beslissingen in het moment, wanneer het er echt toe doet.`)
};

const da_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træning på banen: valg af slag, banestrategi, afstande mellem køllerne og beslutninger i realtid i de øjeblikke, der virkelig betyder noget.`)
};

const nb_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening på banen: slagvalg, banestrategi, avstander mellom køllene og beslutninger i sanntid i øyeblikkene som virkelig teller.`)
};

const fi_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmennus kentällä: lyöntivalinnat, kenttästrategia, mailojen väliset lyöntipituudet ja päätökset reaaliajassa niinä hetkinä, joilla on todella merkitystä.`)
};

const pl_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening na polu: wybór uderzenia, strategia gry na polu, odstępy odległości między kijami i podejmowanie decyzji na bieżąco w momentach, które naprawdę się liczą.`)
};

const ru_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренировка на поле: выбор удара, стратегия игры на поле, разница в дальности между клюшками и решения в реальном времени в моменты, которые действительно важны.`)
};

const tr_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahada koçluk: vuruş seçimi, saha stratejisi, sopalar arasındaki mesafe farkları ve gerçekten önemli anlarda anlık karar verme.`)
};

const hi_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोर्स पर कोचिंग: शॉट का चुनाव, कोर्स मैनेजमेंट, क्लबों के बीच दूरी का अंतर और उन पलों में तुरंत फ़ैसले जो सच में मायने रखते हैं।`)
};

const id_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatihan di lapangan: pemilihan pukulan, strategi lapangan, jarak antar stik, dan pengambilan keputusan secara langsung pada momen-momen yang benar-benar penting.`)
};

const ms_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bimbingan di padang: pemilihan pukulan, strategi padang, jurang jarak antara kayu golf dan membuat keputusan secara langsung pada saat-saat yang benar-benar penting.`)
};

const cs_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trénink na hřišti: volba úderu, strategie hry na hřišti, rozestupy délek mezi holemi a rozhodování v reálném čase ve chvílích, na kterých opravdu záleží.`)
};

const el_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προπόνηση στο γήπεδο: επιλογή χτυπήματος, στρατηγική στο γήπεδο, αποστάσεις ανάμεσα στα μπαστούνια και αποφάσεις σε πραγματικό χρόνο τις στιγμές που πραγματικά μετράνε.`)
};

const he_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אימון במגרש: בחירת חבטות, ניהול מגרש, פערי מרחק בין המחבטים וקבלת החלטות בזמן אמת ברגעים שבאמת חשובים.`)
};

const af_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrigting op die baan: houkeuse, baanstrategie, afstande tussen jou stokke en besluite intyds op die oomblikke wat regtig saak maak.`)
};

const hu_lessons_format_playing_body = /** @type {(inputs: Lessons_Format_Playing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edzés a pályán: ütésválasztás, pályastratégia, az ütők közötti távolságkülönbségek és valós idejű döntések azokban a pillanatokban, amelyek igazán számítanak.`)
};

/**
* | output |
* | --- |
* | "On-course coaching: shot selection, course management, club gapping, and live decision-making in the moments that actually count." |
*
* @param {Lessons_Format_Playing_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_playing_body = /** @type {((inputs?: Lessons_Format_Playing_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Playing_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_playing_body(inputs)
	if (locale === "de") return de_lessons_format_playing_body(inputs)
	if (locale === "zh") return zh_lessons_format_playing_body(inputs)
	if (locale === "ar") return ar_lessons_format_playing_body(inputs)
	if (locale === "fr") return fr_lessons_format_playing_body(inputs)
	if (locale === "vi") return vi_lessons_format_playing_body(inputs)
	if (locale === "sw") return sw_lessons_format_playing_body(inputs)
	if (locale === "th") return th_lessons_format_playing_body(inputs)
	if (locale === "bs") return bs_lessons_format_playing_body(inputs)
	if (locale === "ja") return ja_lessons_format_playing_body(inputs)
	if (locale === "ko") return ko_lessons_format_playing_body(inputs)
	if (locale === "pt") return pt_lessons_format_playing_body(inputs)
	if (locale === "it") return it_lessons_format_playing_body(inputs)
	if (locale === "sv") return sv_lessons_format_playing_body(inputs)
	if (locale === "nl") return nl_lessons_format_playing_body(inputs)
	if (locale === "da") return da_lessons_format_playing_body(inputs)
	if (locale === "nb") return nb_lessons_format_playing_body(inputs)
	if (locale === "fi") return fi_lessons_format_playing_body(inputs)
	if (locale === "pl") return pl_lessons_format_playing_body(inputs)
	if (locale === "ru") return ru_lessons_format_playing_body(inputs)
	if (locale === "tr") return tr_lessons_format_playing_body(inputs)
	if (locale === "hi") return hi_lessons_format_playing_body(inputs)
	if (locale === "id") return id_lessons_format_playing_body(inputs)
	if (locale === "ms") return ms_lessons_format_playing_body(inputs)
	if (locale === "cs") return cs_lessons_format_playing_body(inputs)
	if (locale === "el") return el_lessons_format_playing_body(inputs)
	if (locale === "he") return he_lessons_format_playing_body(inputs)
	if (locale === "af") return af_lessons_format_playing_body(inputs)
	if (locale === "hu") return hu_lessons_format_playing_body(inputs)
	return en_lessons_format_playing_body(inputs)
});